import styled from 'styled-components';

import { Flex } from '../Flexbox/Flex';

type Props = {
  readonly numberOfSteps: number;
  readonly currentStepPosition: number;
};

type StyleDotProps = {
  isDotActive: boolean;
};

const StyledDot = styled.div<StyleDotProps>`
  height: 10px;
  width: 10px;
  border-radius: 50%;
  background-color: ${({ theme, isDotActive }) =>
    isDotActive ? theme.orbit.paletteProductNormal : theme.orbit.paletteCloudNormal};
  margin-left: -1px;
  z-index: ${({ theme }) => theme.orbit.zIndexModal};
`;

type LineProps = {
  isLineActive: boolean;
};

const Line = styled.div<LineProps>`
  height: 4px;
  width: 14px;
  margin-left: -1px;
  background-color: ${({ theme, isLineActive }) =>
    isLineActive ? theme.orbit.paletteProductNormal : theme.orbit.paletteCloudNormal};
`;

type DotProps = {
  readonly isDotActive: boolean;
  isLineActive: boolean;
  isLast: boolean;
};

const Dot = ({ isDotActive, isLineActive, isLast }: DotProps) => (
  <>
    <StyledDot data-test="StepsDot" isDotActive={isDotActive} />
    {!isLast && <Line data-test="StepsLine" isLineActive={isLineActive} />}
  </>
);

const Steps = ({ numberOfSteps, currentStepPosition }: Props): JSX.Element => {
  const dots = new Array(numberOfSteps).fill(Dot);
  return (
    <Flex alignItems="center">
      {dots.map((Component, index) => (
        <Component
          key={index}
          isLast={dots.length - 1 === index}
          isDotActive={currentStepPosition > index}
          isLineActive={currentStepPosition - 1 > index}
        />
      ))}
    </Flex>
  );
};

export default Steps;
